import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [profileDetails, setProfileDetails] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem("userInfo") || localStorage.getItem("profileDetails") || "{}"
      );
    } catch (e) {
      return {};
    }
  });

  useEffect(() => {
    const updateFromStorage = () => {
      try {
        const pd = JSON.parse(
          localStorage.getItem("userInfo") || localStorage.getItem("profileDetails") || "{}"
        );
        setProfileDetails(pd);
      } catch (e) {
        // ignore parse errors
      }
    };

    const onStorage = (e) => {
      // e.key may be null for clear(); update conservatively
      if (!e.key || e.key === "userInfo" || e.key === "profileDetails") updateFromStorage();
    };

    // Handle cross-tab updates
    window.addEventListener("storage", onStorage);

    // Handle same-tab updates: code that writes userInfo/profileDetails should dispatch this event
    const onCustom = () => updateFromStorage();
    window.addEventListener("profileDetailsUpdated", onCustom);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("profileDetailsUpdated", onCustom);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ profileDetails, setProfileDetails }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  // Prevent runtime crash if AuthProvider is missing. Provide a safe empty object so callers can read properties without throwing.
  return ctx || { profileDetails: {}, setProfileDetails: () => {} };
};

